import { Breadcrumb } from "antd";
// import axios from "axios";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { NavLink, useParams } from "react-router-dom";
import { settings } from "../../../../utils/config";
import { useNotify } from "../../../../components/Notification";
// import { baseUrl } from "../../../../components/common/baseUrl";
import { getMenuOfUser } from "../../../../redux/menu/getMenuOfUser";
import CreateMenuForm from "./CreateMenuForm";
import { menuAPIWithErrorHandling } from "../../../../api/menus/menu";

const EditMenuPage = () => {
  const { id } = useParams();
  const notify = useNotify();
  const hasAccessToken = settings?.getCookie("access_token");
  const dispatch = useDispatch();

  //#region  state
  const [dataDetailMenu, setDataDetailMenu] = useState();
  //#endregion state

  //#region  function
  const fetchActions = async (page = 1, perPage = 10) => {
    try {
      // const url = `${baseUrl}/api/v1/security/menus/${id}`;
      // const response = await axios.get(url, {
      //   headers: {
      //     "Content-Type": "application/json",
      //     Authorization: `Bearer ${hasAccessToken}`,
      //   },
      // });
      const response = await menuAPIWithErrorHandling.getById(id);

      if (response.data.success && response.data.data) {
        const result = response.data.data;
        setDataDetailMenu(result || []);
      }
    } catch (error) {
      notify.error({
        message: "Thất bại",
        description: error?.message,
      });
    } finally {
    }
  };

  const handleUpdate = async (data) => {
    const request = {
      name: data.name,
      slug: data.key,
      url: data.url,
      parent_id: data.parent_id || null,
      icon: data.icon,
      permission_ids: data.listPermission.map((item) => item.id),
    };

    try {
      // const response = await axios.put(
      //   `${baseUrl}/api/v1/security/menus/${id}`,
      //   request,
      //   {
      //     headers: {
      //       Authorization: `Bearer ${hasAccessToken}`,
      //     },
      //   }
      // );

      const response = await menuAPIWithErrorHandling.update(id, request);

      if (response) {
        notify.success({
          message: "Thành công",
          description: "Cập nhật menu thành công!",
        });
        fetchActions();
        // Vừa cập nhật menu -> bỏ qua cửa sổ dedupe của SWR, lấy bản mới ngay.
        dispatch(getMenuOfUser({ force: true }));
      }
    } catch (error) {
      // const errorMessages = Object.entries(error)
      //   .map(([field, messages]) => `${field}: ${messages.join(", ")}`)
      //   .join(" | ");
      notify.error({
        message: "Thất bại",
        description: error?.message || "Vui lòng kiểm tra lại thông tin!",
      });
    } finally {
    }
  };

  useEffect(() => {
    fetchActions();
  }, []);

  return (
    <>
      <Breadcrumb separator=">">
        <Breadcrumb.Item>
          <NavLink to="/menu" style={{ textDecoration: "none" }}>
            Danh sách Menu
          </NavLink>
        </Breadcrumb.Item>
        <Breadcrumb.Item>Thông tin chung của Menu</Breadcrumb.Item>
      </Breadcrumb>
      <CreateMenuForm
        handleSubmit={(data) => handleUpdate(data)}
        title={"Thông tin chung"}
        initData={dataDetailMenu}
      />
    </>
  );
};
export default EditMenuPage;
